import React from "react";
import {GroupBase, Props as IReactSelectProps} from "react-select";
import CreatableSelect from "react-select/creatable";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useSelectTheme} from "../hooks/use_select_theme";

import {iconStyle} from "./Select.module.css";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface ISelectProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> extends IReactSelectProps {
    isBorderless?: boolean;
    labelContent?: string;
    className?: string;
    placeholder?: string;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string}) => {
    if (props.hasLabel) {
        return <div className={props.className}>{props.children}</div>;
    }
    return <>{props.children}</>;
};

export function SelectCreatable<Option>(props: ISelectProps<Option>) {
    const {getTheme, styles} = useSelectTheme();
    const {labelContent, isBorderless, className, placeholder, ...restProps} = props;

    return (
        <Wrapper hasLabel={!!labelContent} className={className}>
            {labelContent ? (
                <Text mb={0.5} variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <CreatableSelect
                components={{
                    DropdownIndicator: (state) => {
                        return <ChevronDownIcon className={iconStyle} size="2" fill={`var(--colors-gray-${state.isDisabled ? "300" : "700"})`} />;
                    }
                }}
                isSearchable={false}
                styles={{
                    ...styles,
                    ...(isBorderless && {
                        control: (provided) => ({
                            ...provided,
                            boxShadow: "none",
                            border: "none"
                        })
                    })
                }}
                theme={getTheme}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
            />
        </Wrapper>
    );
}
import React from "react";
import {GroupBase, Props as IReactSelectProps} from "react-select";
import CreatableSelect from "react-select/creatable";

import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useSelectTheme} from "../hooks/use_select_theme";

import {iconStyle} from "./Select.module.css";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface ISelectProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> extends IReactSelectProps {
    isBorderless?: boolean;
    labelContent?: string;
    className?: string;
    placeholder?: string;
}

const Wrapper = (props: {children: (React.ReactNode | null)[]; hasLabel?: boolean; className?: string}) => {
    if (props.hasLabel) {
        return <div className={props.className}>{props.children}</div>;
    }
    return <>{props.children}</>;
};

export function SelectCreatable<Option>(props: ISelectProps<Option>) {
    const {getTheme, styles} = useSelectTheme();
    const {labelContent, isBorderless, className, placeholder, ...restProps} = props;

    return (
        <Wrapper hasLabel={!!labelContent} className={className}>
            {labelContent ? (
                <Text mb={0.5} variant="body_copy_2" as="div">
                    {labelContent}
                </Text>
            ) : null}
            <CreatableSelect
                components={{
                    DropdownIndicator: (state) => {
                        return <ChevronDownIcon className={iconStyle} size="2" fill={`var(--colors-gray-${state.isDisabled ? "300" : "700"})`} />;
                    }
                }}
                isSearchable={false}
                styles={{
                    ...styles,
                    ...(isBorderless && {
                        control: (provided) => ({
                            ...provided,
                            boxShadow: "none",
                            border: "none"
                        })
                    })
                }}
                theme={getTheme}
                {...restProps}
                className={!labelContent ? className : undefined}
                placeholder={placeholder || "Wybierz"}
            />
        </Wrapper>
    );
}
